import React, { Fragment } from 'react';
import styled from 'styled-components';
import { scrims } from '../../config/theme';

const ModalWrapper = styled.div`
  width: 90%;
  max-width: 500px;
  height: auto;
  z-index: 1001;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: ${scrims.modal};
  z-index: 1000;
`;

export const Modal = ({ isOpen, children, onClose }) => {
  return (
    <Fragment>
      {isOpen ? (
        <Fragment>
          <ModalWrapper>{children}</ModalWrapper>
          <ModalOverlay onClick={onClose} />
        </Fragment>
      ) : null}
    </Fragment>
  );
};

export default Modal;
